import { IRequestCommand } from '../../authentication/connection/iRequestCommand';
import { CommandRequestType } from '../../authentication/connection/commandRequestType';
import { ICommandParameters } from '../../authentication/connection/iCommandParameters';
import { ICommandResponse } from '../../authentication/connection/iCommandResponse';
import {
  ErrorDetails,
  DriverResponseDTO,
  GridRequestDto
} from '../../interfaces/apiInterfaces';

export class GetOwnerDriverCommand extends IRequestCommand<
  IGetOwnerDriverResponse,
  ErrorDetails,
  IGetOwnerDriversCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl =
    'carriers/{carrierUserId}/drivers/owner/{ownerId}/paginated?page={page}&size={size}&column={column}&sort={sort}&value={value}&state={state}&operability={operability}';

  constructor(dashboard: boolean = false) {
    super();

    this._commandUrl = dashboard
      ? 'carriers/{carrierUserId}/drivers/owner/{ownerId}/dashboard?page={page}&size={size}&column={column}&sort={sort}&value={value}&state={state}&operability={operability}&driverId={driverId}&vehicleIdSwitch={vehicleIdSwitch}'
      : this._commandUrl;
  }

  public override setParameters(parameters: IGetOwnerDriversCommandParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{carrierUserId}',
      parameters.carrierUserId.toString()
    );
    this._commandUrl = this._commandUrl.replace(
      '{ownerId}',
      parameters.ownerId.toString()
    );

    this._commandUrl = this._commandUrl.replace(
      '{page}',
      parameters.page.toString()
    );
    this._commandUrl = this._commandUrl.replace(
      '{size}',
      parameters.size.toString()
    );
    this._commandUrl = this._commandUrl.replace(
      '{column}',
      parameters.column.toString()
    );
    this._commandUrl = this._commandUrl.replace(
      '{sort}',
      parameters.sort.toString()
    );
    this._commandUrl = this._commandUrl.replace(
      '{state}',
      parameters.state.toString()
    );
    this._commandUrl = this._commandUrl.replace(
      '{operability}',
      parameters.operability.toString()
    );
    this._commandUrl = this._commandUrl.replace('{value}', parameters.find);

    this._commandUrl = this._commandUrl.replace(
      '{driverId}',
      parameters.findDriverId ? parameters.findDriverId : ''
    );

    this._commandUrl = this._commandUrl.replace(
      '{operability}',
      parameters.operability ? String(parameters.operability) : 'true'
    );

    this._commandUrl = this._commandUrl.replace(
      '{vehicleIdSwitch}',
      parameters.vehicleIdSwitch ? String(parameters.vehicleIdSwitch) : 'false'
    );
  }
}

export interface IGetOwnerDriversCommandParameters
  extends ICommandParameters,
  GridRequestDto {
  ownerId: string;
  state: string;
  vehicleIdSwitch?: boolean;
}

export interface IGetOwnerDriverResponse
  extends DriverResponseDTO,
  ICommandResponse { }
